<template>
  <div :class="['bordered-box', `bordered-box--${variant}`]">
    <div
      v-if="title"
      :class="[
        'bordered-box__title',
        { 'bordered-box__title--inverted': invertedTitle },
      ]"
    >
      {{ title }}
    </div>
    <div class="bordered-box__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
  variant?: "default" | "stamp" | "vertical";
  invertedTitle?: boolean;
}

withDefaults(defineProps<Props>(), {
  title: undefined,
  variant: "default",
  invertedTitle: false,
});
</script>

<style scoped>
.bordered-box {
  display: inline-flex;
  flex-direction: column;
  border: 3px solid var(--color-text-base);
  font-family: var(--font-family-body);
}

/* Title */
.bordered-box__title {
  padding: 0.4em 0.75em;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 3px solid var(--color-text-base);
  text-align: center;
}

.bordered-box__title--inverted {
  background: var(--color-text-base);
  color: var(--color-text-inverted);
  font-weight: var(--font-weight-bold);
  border-bottom: none;
}

/* Content */
.bordered-box__content {
  padding: 0.75em;
  display: flex;
  align-items: center;
  gap: 0.75em;
}

/* Variants */
.bordered-box--default {
  border-radius: 0;
}

.bordered-box--stamp {
  border-radius: 0;
}

.bordered-box--stamp .bordered-box__content {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1.4;
}

.bordered-box--vertical {
  border-width: 4px;
}

.bordered-box--vertical .bordered-box__content {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 1em 0.5em;
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.6;
}
</style>
